import { EventItem, EventApi } from "./EventApi";

import { DiscoveryApi, FetchApi } from "@backstage/core-plugin-api";


export class EventApiClient implements EventApi {   

    constructor(private readonly discoveryApi: DiscoveryApi, private readonly fetchApi: FetchApi) {}

    async listEvents(): Promise<EventItem[]> {
        const baseUrl = await this.discoveryApi.getBaseUrl('test');
        const response = await this.fetchApi.fetch(`${baseUrl}/events`);
        return response.json();
    }

    async getEvent(id: string): Promise<EventItem> {
        const baseUrl = await this.discoveryApi.getBaseUrl('test');
        const response = await this.fetchApi.fetch(`${baseUrl}/events/${id}`);
        if (!response.ok) {
            throw new Error(`Failed to fetch event with id ${id}`);
        }
        return response.json();
    }

    async createEvent(event: Omit<EventItem, 'id' | 'createdAt' | 'updatedAt'>): Promise<EventItem> {
        const baseUrl = await this.discoveryApi.getBaseUrl('test');
        const response = await this.fetchApi.fetch(`${baseUrl}/events`, {
            method: 'POST',
            body: JSON.stringify(event),
            headers: {
                'Content-Type': 'application/json',
            },
        });
        if (!response.ok) {
            throw new Error('Failed to create event');
        }
        return response.json();
    }

    async updateEvent(id: string, data: Partial<Omit<EventItem, 'id' | 'createdAt' | 'updatedAt'>>): Promise<EventItem> {
        const baseUrl = await this.discoveryApi.getBaseUrl('test');
        const response = await this.fetchApi.fetch(`${baseUrl}/events/${id}`, {
            method: 'PUT',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json',
            },
        });
        if (!response.ok) {
            throw new Error(`Failed to update event with id ${id}`);
        }
        return response.json();
    }

    async deleteEvent(id: string): Promise<void> {
        const baseUrl = await this.discoveryApi.getBaseUrl('test');
        const response = await this.fetchApi.fetch(`${baseUrl}/events/${id}`, {
            method: 'DELETE',
        });
        if (!response.ok) {
            throw new Error(`Failed to delete event with id ${id}`);
        }
    }


}